export const getDeviceCustomerContactInfo = (state, deviceId) => {
  const filtered = state.deviceContacts.filter((c) => c.deviceId === deviceId);
  if (filtered.length > 0) {
    return filtered[0].contactInfo;
  }

  return [];
};
